import { render, staticRenderFns } from "./NotificationDetailingModal.vue?vue&type=template&id=aa1d0798&scoped=true&"
import script from "./NotificationDetailingModal.vue?vue&type=script&lang=ts&"
export * from "./NotificationDetailingModal.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationDetailingModal.vue?vue&type=style&index=0&id=aa1d0798&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa1d0798",
  null
  
)

export default component.exports